import { ApiService, type ApiRequestConfig } from "./api.service";

export interface ITimezoneOption {
  value: string;
  label: string;
  utc_offset: string;
  gmt_offset: string;
}

export class TimezoneService extends ApiService {
  async listTimezones(config?: ApiRequestConfig): Promise<ITimezoneOption[]> {
    const response = await this.get<{ timezones: ITimezoneOption[] }>("/api/timezones/", config);
    return response.timezones;
  }
}
